import { render } from "./UsersTabular.vue?vue&type=template&id=1d99ab47"
import script from "./UsersTabular.vue?vue&type=script&lang=js"
export * from "./UsersTabular.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__